import { Text } from '@/components/atoms/text';
import { MapLegendContainer, MapLegendItem } from './styles';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from '@/hooks/useTranslation';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';
import { useMediaQuery } from '@mui/material';

interface MapLegendProps {
  variant: 'risk' | 'opportunity';
}

export const MapLegend = ({ variant }: MapLegendProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { t } = useTranslation();

  const opportunityLegend = [
    {
      label: t('label.label.high_opportunity'),
      backgroundColor: theme.palette['mint-green'][700],
    },
    {
      label: t('label.label.medium_high_opportunity'),
      backgroundColor: theme.palette.primary.main,
    },
    {
      label: t('label.label.medium_low_opportunity'),
      backgroundColor: theme.palette['mint-green'][400],
    },
    {
      label: t('label.label.low_opportunity'),
      backgroundColor: theme.palette['mint-green'][250],
    },
  ];

  const riskLegend = [
    {
      label: t('label.label.high_risk'),
      backgroundColor: theme.palette.orange[850],
    },
    {
      label: t('label.label.medium_high_risk'),
      backgroundColor: theme.palette.orange[500],
    },
    {
      label: t('label.label.medium_low_risk'),
      backgroundColor: theme.palette.orange[350],
    },
    {
      label: t('label.label.low_risk'),
      backgroundColor: theme.palette.orange[200],
    },
  ];

  const mapLegend = useMemo(() => {
    if (variant === 'opportunity') {
      return opportunityLegend;
    }
    return riskLegend;
  }, [variant, t]);

  return (
    <MapLegendContainer>
      {mapLegend.map((item, index) => (
        <MapLegendItem key={index} backgroundColor={item.backgroundColor}>
          <Text
            variant={isMobile ? 'caption' : 'subtitle2'}
            color={
              item.label === `${t('label.label.high_opportunity')}` ||
              item.label === `${t('label.label.high_risk')}`
                ? 'common.white'
                : 'text.primary'
            }
          >
            <SafeMarkdown text={item.label || ''} />
          </Text>
        </MapLegendItem>
      ))}
    </MapLegendContainer>
  );
};
